import React, {useEffect, useState} from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import MotifPaginationSelect from '@ey/motif-react-wrapper/PaginationSelect';
import MotifPaginationSelectItem from '@ey/motif-react-wrapper/PaginationSelectItem';

import StyledMotifPagination from './StyledMotifPagination';

const Pagination = ({
	showLabel = 'Show',
	dataLength = 0,
	currentPage = 1,
	pageSize = 20,
	options = [20, 50, 100, 200],
	onChange = null,
	selectPosition = 'top',
	className = null,
	...rest
}) => {
	const [current, setCurrent] = useState(currentPage);
	const [size, setSize] = useState(pageSize);

	const max = Math.ceil(dataLength / size);

	const renderOptiom = (option, index) => {
		const props = {
			key: index,
			onClick: () => {
				setCurrent(1);
				setSize(option);
				onChange && onChange({current: 1, pageSize: option});
			},
			selected: size === option,
			children: `${option}`.trim()
		};
		return <MotifPaginationSelectItem {...props} />;
	};

	const firstProps = {disabled: current === 1};
	const lastProps = {disabled: current === max};

	const props = {
		...rest,
		allowInput: false,
		currentPage: current,
		max,
		onPageChange: (newCurrent) => {
			setCurrent(newCurrent);
			onChange && onChange({current: newCurrent, pageSize: size});
		},
		firstButtonProps: firstProps,
		prevButtonProps: firstProps,
		lastButtonProps: lastProps,
		nextButtonProps: lastProps,
		className: classNames({[`${className}`]: className, ['open-top']: selectPosition === 'top'})
	};

	const displayOptions = selectPosition === 'top' ? [...options].reverse() : [...options];

	return (
		<StyledMotifPagination {...props}>
			<span className={'show-label'}>{showLabel}</span>
			<MotifPaginationSelect>{displayOptions.map(renderOptiom)}</MotifPaginationSelect>
		</StyledMotifPagination>
	);
};

Pagination.propTypes = {
	showLabel: PropTypes.string,
	dataLength: PropTypes.number,
	current: PropTypes.number,
	pageSize: PropTypes.number,
	options: PropTypes.arrayOf(PropTypes.number),
	onChange: PropTypes.func,
	selectPosition: PropTypes.oneOf(['top', 'bottom']),
	className: PropTypes.string
};

export default Pagination;
